module.exports = __webpack_public_path__ + "static/media/UK.db68882c.svg";